export const ReviewTemplateStatus = {
    DRAFT: 'Draft',
    INACTIVE: 'Inactive',
    ACTIVE: 'Active',
} as const;

export type ReviewTemplateStatus = (typeof ReviewTemplateStatus)[keyof typeof ReviewTemplateStatus];
